<template>

<div  class="container-fluid">

<div class="card border-primary " >
  <div class="card-header bg-primary text-white ">

    <h4 >
       <i style="color:yellow" class="fas fa-dolly mr-2" aria-hidden="true"></i>
      CONSEGNA ORDINE FORNITORE</h4>
  </div>
  <div class="card-body text-black ">

    <!-- ORDERS LIST -->
<div class=""  v-if = "type == 'A'">
    <supplier-orders @update="setProductsList"></supplier-orders>
</div>

<!-- PRODUCTS LIST -->
<div v-else-if = "type == 'B'">

  <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
          <li v-if="card=='B'" @click="type='A',card='B'"   class="breadcrumb-item"><a href="#">
            <i style="color:rgb(18, 50, 228)" class="fas fa-binoculars mr-2" aria-hidden="true"></i>
            RICERCA ORDINE</a></li>

            <li v-if="card=='A'" @click="card='B'" class="breadcrumb-item"><a href="#">
            <i style="color:rgb(18, 50, 228)" class="fas fa-reply mr-2" aria-hidden="true"></i>
            MOSTRA LISTA PRODOTTI</a></li>
            
          
          </ol>
        </nav>





<!--
  <button v-if="card=='B'" @click="type='A',card='B'" type="button"  class="btn  btn-secondary mb-1  btn-block">
              <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
              RITORNA A RICERCA ORDINI
  </button> 
  <button v-if="card=='A'" @click="card='B'" type="button"  class="btn  btn-secondary mb-1 btn-block">
            <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
            RITORNA A LISTA PRODOTTI
        </button> 

      -->

    <div class="card text-black border-info"> 
      <h4 class="card-header border-success header_1">

       
      

        <order-info :key="orderInfoKey" v-bind:orderId="order.orderId"></order-info>


      </h4>

      <div class="card-body ">
      
        <div v-if="card=='B'">
          <products-list v-bind:printLabels="true" @update="setConfirmDetail" :key="productsKey" v-bind:orderId="order.orderId" v-bind:type="'confirm'"></products-list>
         <!--
          <div class="card text-center">
            <div class="card-header " style="color:#000080;background-color:#E1E1E1">
              <strong>PER CONSEGNA ORDINE SELEZIONA PRODOTTO CON DOPPIO CLICK.</strong>
            </div>
            <div class="card-body">
              <h4><strong>ULTIMO PRODOTTO AGGIORNATO ID {{product.productId}}</strong></h4>
           </div>
        </div>
        -->
      </div>

      <div v-if="card=='A'" class="card text-black mb-1 border-success"> 
       
      <h4 class="card-header border-success">
      
        <h4 style="color:brown"><strong>CONSEGNA ORDINE</strong></h4>
        <product-info :key="productKey" v-bind:productId="product.productId"></product-info> 
       
      </h4>

      <div class="card-body border-success">      
        <product-qty-delivery @update="setCard" @updateDoc="setDoc"  :key="detailKey" v-bind:productId="product.productId" v-bind:order="order"  v-bind:_doc="doc" ></product-qty-delivery>         
      </div>
       
    </div>   


      </div>
    </div>   
    
</div> 
  
  </div>
</div>    


  
<!-- MAIN DIV -->
</div>

</template>
<script>

import { mapGetters }      from 'vuex';
import supplierOrders      from '@/components/order/SupplierOrders.vue';
import productsList        from '@/components/order/OrderProducts.vue';
import orderInfo           from '@/components/order/OrderInfo.vue';
import productInfo         from '@/components/product/ProductInfo.vue';
import productQtyDelivery  from '@/components/order/ProductQtyDelivery.vue';

export default {
  
  components: {supplierOrders,productsList,orderInfo,productQtyDelivery,productInfo},  
  
  /*props: ['form'],*/

  data () {
    return {
    
      
      card        : 'B',
      type         : 'A',
      product      : {'productId':0,},
      productKey   : 0,
      productsKey  : 0,
      detailKey    : 0,
      order        : {},
      orderInfoKey : 0,
    
    

      doc            : {}
    
  }
  },

computed: 
{
  ...mapGetters(['company']),
},
mounted()
{},
created()
{},

methods: 
{


  setDoc(data)
  {
    this.doc = data
  },

  setProductsList(order)
  {

    this.doc   = {}
    this.order = order
    this.type = 'B'

  }, 


  setConfirmDetail(productId)
  {
    if(productId > 0)
    {
      this.card = 'A'
      this.product.productId = productId
      this.productKey++
      this.detailKey++
    }
    else
    {
      this.card = 'B'
    }
  },
  setProductPriceDetail(barcodes,sizes,counter)
  {
    this.product.barcodes = barcodes
    this.product.sizes = sizes
    this.product.counter = counter
    this.type = 'D'
  },
  setCard()
  {
    this.productsKey++
    this.card = 'B'

  },
 
 
 
  
      
}
    
}    
</script>

<style scoped>

.bold {
  font-weight: bolder;
}

h4,span {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

.header_1 {
 
  background-color: beige;
}


</style>